<template>
  <div>
    <b-table striped hover :fields="booklist_field" :items="items">
      <template #cell(NO)="data">
        {{ data.index + 1 }}
      </template>
      <template #cell(ISBN)="data">
        {{ data.item.isbn }}
      </template>
      <template #cell(교재명)="data">
        <a :href="`/admin/book/form?id=${data.item.id}`">{{
          data.item.title
        }}</a>
      </template>
      <template #cell(저작자)="data">
        {{ data.item.owner }}
      </template>
      <template #cell(유닛관리)="data">
        <b-button variant="success" size="sm" @click="mgrU(data)"
          >유닛 관리</b-button
        >
      </template>
      <template #cell(문제은행)="data">
        <b-button variant="primary" size="sm" @click="addQ(data)"
          >문제은행 관리</b-button
        >
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: ["page"],
  watch: {
    page: {
      handler(to, from) {
        // alert(to);
        this.$store.dispatch("loadBookList", to);
      },
      immediate: true,
    },
  },
  computed: {
    items() {
      return this.$store.state.booklist;
    },
    booklist_field() {
      return this.$store.state.booklist_field;
    },
  },
  methods: {
    addQ(data) {
      // this.$router.push({ query: { m: "new" } });
      let book_id = data.item.id;
      this.$router.push({
        path: "/admin/question/list",
        query: { book_id: book_id },
      });
    },
    mgrU(data) {
      let book_id = data.item.id;
      this.$router.push({
        path: "/admin/book/unitmgr",
        query: { book_id: book_id },
      });
    },
  },
};
</script>


<style lang="scss" scoped>
</style>